import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
import { SelectOfferInput } from "../types/types";

const SELECT_OFFER_MUTATION = gql(`
  mutation SelectOffer($input: SelectOfferInput!) {
  selectOffer(input: $input)
}
`);

export function useSelectOffer() {
  const { setOfferId } = useGeneralSoContext();
  const [mutation, info] = useMutation(SELECT_OFFER_MUTATION);
  const selectOffer = async (input: SelectOfferInput) => {
    const { data } = await mutation({
      variables: { input },
    });
    if (data?.selectOffer) {
      setOfferId(data.selectOffer);
    }
    return data;
  };
  return [selectOffer, info] as const;
}
